module.exports = __webpack_public_path__ + "img/5-4.2c73e63e.svg";